<template>
  <!--layout3 2图文 -->
  <div class="article-box">
    <div class="article-box-wrap" @click="go(dataItem)">
      <div v-if="index == 0" class="article-box-wrap-first">
        <img :src="dataItem.cover_img" alt="" />
        <div class="article-box-wrap-first-bot">
<!--          <div>{{ dataItem.title }}</div>-->
          <div>
            <span class="desc">{{ dataItem.created_at }}</span>
          </div>
        </div>
        <div class="article-box-wrap-first-icon">
        </div>
<!--        <div class="article-box-wrap-first-bg">-->
<!--        </div>-->
      </div>
      <div v-else class="article-box-wrap-other" :class="[index == 1 ? 'chu': '']">
        <img :src="dataItem.cover_img" alt="" />
        <div class="article-box-wrap-other-bot">
          <div>{{ dataItem.title }}</div>
          <div class="desc" v-if="dataItem.type == 2">
            共{{ dataItem.total_count }}篇
            <span style="margin-left: 5px">{{ dataItem.view_count }}人阅读</span>
          </div>
          <div v-else>
            <span class="desc">{{  dataItem.view_count ? dataItem.view_count : 0 }}人阅读</span>
          </div>
        </div>
        <div class="article-box-wrap-other-icon">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Interface from '@/util/interface'

export default {
    name: 'Article',
    props: {
        dataItem: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        }
    },
    filters: {
        omitTitle(value) {
            if (value.length > 18) {
                return value.slice(0, 18) + '...'
            } else {
                return value
            }
        }
    },
    methods: {
      go(item) {
        if (item.type == 2) {
          this.$router.push({ name: 'article-column', params: { id: item.origin_id } })
        } else {
          this.$router.push({ name: 'article-detail', params: { id: item.origin_id } })
        }
        Interface.mFootPrint(item.origin_id,2,0,5,0, item.title)
      }
        // getViewCount(row) {
        //     Interface.getData(
        //         "get",
        //         `/course-phase/api/recommend_v2/${row.id}/view`
        //     );
        // }
    }
}
</script>

<style lang="scss" scoped>
.article-box{
  &-wrap{
    display: inline-block;
    &:nth-child(2n){
      margin-right: 11px;
    }
    &-first{
      position: relative;
      width: 331px;
      height: 184px;
      margin-top: 6px;
      img{
        width: 100%;
        height: 184px;
        border-radius: 6px;
      }
      &-bot{
        position: absolute;
        bottom: 0px;
        width: 100%;
       //  background-image: linear-gradient(180deg, rgba(51,51,51,0.00) 0%, rgba(0,0,0,0.40) 99%);
        padding-bottom: 10px;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        div:nth-child(1){
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #FFFFFF;
          padding-left: 14px;
        }
        div:nth-child(2){
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          margin-top: 8px;
          color: #fff;
          font-size: 12px;
          font-family: HarmonyOS_Sans_SC;
          color: #FFFFFF;
          padding: 0 14px 0 14px;
          .desc{
            font-size: 12px;
            font-family: HarmonyOS_Sans_SC;
            color: #FFFFFF;
            line-height: 18px;
          }
          .apply{
            width: 94px;
            height: 32px;
          }
        }
      }
      &-bg{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 331px;
        height: 100px;
        background: linear-gradient(180deg, rgba(34,34,34,0) 0%, rgba(0,0,0,0.2) 40%, rgba(0,0,0,0.5) 100%);
        border-radius: 0px 0px 6px 6px;
      }
      &-icon{
        position: absolute;
        left: 3px;
        top:4px;
        img{
          width: 54px;
          height: 18px;
          border-radius: 4px;
        }
      }
    }
    &-other{
      display: inline-block;
      position: relative;
      width: 160px;
      margin-top: 14px;
      img{
        width: 100%;
        height: 90px;
        border-radius: 6px;
      }
      &-bot{
        width: 100%;
        float: left;
        height: 65px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-top: 9px;
        div:nth-child(1){
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #222222;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp:2;
        }
        div:nth-child(2){
          // margin-top: 10px;
          .desc{
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #979797;
          }
        }
        .desc{
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #979797;
        }
      }
      &-icon{
        position: absolute;
        left: 4px;
        top: 4px;
        img{
          width: 30px;
          height: 18px;
          border-radius: 4px;
        }
      }
    }
    .chu{
      margin-right: 11px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/hotRecommend/layout3/article.vue